import { createFileRoute } from '@tanstack/react-router'
import { InscriptionMerciPage } from '@/pages/InscriptionMerciPage'

export const Route = createFileRoute('/inscription/merci')({
  component: InscriptionMerciPage,
})
